import { combineReducers } from "redux";
import loginReducer from "./login.reducer";
var appReducer = combineReducers({
    auth: loginReducer,
    test: loginReducer
});
// @ts-ignore
var rootReducer = function (state, action) { return appReducer(state, action); }; // tslint:disable-line no-any
export default rootReducer;
